export default __webpack_public_path__ + "static/media/skunk.03089cbb.png";